// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"93732d8ead34d6b70eb9","532":"0795154aea9580f7eb12","691":"d758830faaa89ee97b4e"}[chunkId] + ".js";
};